export const BaseLineFeedBack2 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22 7C22 4.79086 20.2091 3 18 3H6C3.79086 3 2 4.79086 2 7V14C2 16.2091 3.79086 18 6 18H6.5V20.5L11.5 18H18C20.2091 18 22 16.2091 22 14V7Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path d="M12 7.5V10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
    <path d="M12 13.4998V13.4253" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
);
